// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dh-2";
export var aiChatCartContainerExit = "_dh-4";
export var aiChatContainerLarge = "_dh-0";
export var aiChatContainerSmall = "_dh-1";
export var aiChatIcon = "_dh-6";
export var slideInFromRight = "_dh-3";
export var slideOutToRight = "_dh-5";